import { createStore, createLogger } from "vuex";
import auths from "./modules/auths.module";
import groups from "./modules/groups.module";
import branches from "./modules/branches.module";
import phone from "./modules/phone.module";
import roles from "./modules/roles.module";
import user from "./modules/user.module";
import sms from "./modules/sms.module";
import courses from "./modules/courses.module";
import finance from "./modules/finance.module";
import admin from "./modules/admin.module";
import hr from "./modules/hr.module";
import shop from "./modules/shop.module";
import payment from "./modules/payment.module";

const plugins = [];

if (process.env.NODE_ENV === "development") {
  plugins.push(createLogger());
}

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    groups,
    auths,
    branches,
    phone,
    roles,
    user,
    sms,
    courses,
    finance,
    admin,
    hr,
    shop,
    payment,
  },
});
